<template>
    <div id="guest-register">
        <loading :active.sync="is_loading"></loading>
        <b-container fluid>
            <h3>Información de contacto</h3>
            <b-form class="form-row">
                <div class="col-12">
                    <label class="text-black h6">Todos los datos <span class="text-danger">*</span> son obligatorios </label>
                </div>
                <div class="form-group col-md-6">
                    <b-form-input id="guest-name" type="text" required v-model="user.name" placeholder="Nombre(s) *"></b-form-input>
                </div>
                <div class="form-group col-md-6">
                    <b-form-input id="guest-surname" type="text" required v-model="user.surname" placeholder="Apellido Paterno *"></b-form-input>
                </div>
                <div class="form-group col-md-6">
                    <b-form-input id="guest-lastname" type="text" required v-model="user.lastname" placeholder="Apellido Materno *"></b-form-input>
                </div>
                <div class="form-group col-md-6">
                    <b-form-input id="guest-email" type="email" required v-model="user.email" placeholder="Correo electrónico *"></b-form-input>
                </div>
                <h3 class="col-12 text-center">Dirección de envío</h3><br>
                <b-form-group class="col-12">
                    <b-form-input v-model="user.phone" type="tel" placeholder="Teléfono *" required></b-form-input>
                </b-form-group>
                <b-form-group class="col-12">
                    <b-form-input v-model="address.cp" type="number" placeholder="Código postal *" required></b-form-input>
                </b-form-group>
                <b-form-group class="col-12">
                    <b-form-select v-model="address.state_id">
                        <b-form-select-option value="0" disabled >Selecciona Estado *</b-form-select-option>
                        <b-form-select-option v-for="state in states" :value="state.id" :key="state.id">{{ state.name }}</b-form-select-option>
                    </b-form-select>
                </b-form-group>
                <b-form-group class="col-12">
                    <b-form-select v-model="address.suburb" v-if="has_cp_info">
                        <b-form-select-option value="" disabled>Selecciona Colonia o Asentamiento *</b-form-select-option>
                        <b-form-select-option v-for="suburb in suburbs" :value="suburb.d_asenta" :key="suburb.d_asenta">{{ suburb.d_asenta }}</b-form-select-option>
                    </b-form-select>
                    <b-form-input v-else v-model="address.suburb" type="text" placeholder="Colonia o asentamiento *"></b-form-input>
                </b-form-group>
                <b-form-group class="col-12">
                    <b-form-input v-model="address.municipality" type="text" placeholder="Delegacion o Municipio *" required></b-form-input>
                </b-form-group>
                <b-form-group class="col-12">
                    <b-form-input v-model="address.street" type="text" placeholder="Calle *" required></b-form-input>
                </b-form-group>
                <b-form-group class="col-12">
                    <b-form-input v-model="address.no_int" type="text" placeholder="Número interior"></b-form-input>
                </b-form-group>
                <b-form-group class="col-12">
                    <b-form-input v-model="address.no_ext" type="text" placeholder="Número exterior *" required></b-form-input>
                </b-form-group>
                <b-form-group class="col-12">
                    <b-form-input v-model="address.btw_streets" type="text" placeholder="Entre calles *" required></b-form-input>
                </b-form-group>
                <b-form-group class="col-12">
                    <b-form-input v-model="address.references" type="text" placeholder="Referencias *" required></b-form-input>
                </b-form-group>
                <b-form-group class="col-12">
                    <b-form-checkbox type="radio" id="customRadioInline1" name="customRadioInline1" v-model="address_type" value="1">Para entregar en el buzón de tu casa *</b-form-checkbox>
                    <b-form-checkbox type="radio" id="customRadioInline2" name="customRadioInline1" v-model="address_type" value="2">Alguien deberá firmar de recibido *</b-form-checkbox>
                </b-form-group>
                <button class="btn btn-blue btn-sm mx-auto" type="button" @click="registerGuest" :disabled="is_submit_disabled">Registrar y Pagar</button>
            </b-form>
        </b-container>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import EditAddress from '../EditAddress.vue';
const axios = require("axios");
import { eventBus } from "./../../events.js";

export default {
    name: "GuestForm",
    props: ['changeV', 'accessData'],
    components: {
        Loading,
        EditAddress,
    },
    data() {
        return {
            api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
            user: {
                email: "",
                name: "",
                surname: "",
                lastname: "",
                phone: "",
            },
            user_registered_id: null,
            address: {},
            is_loading: false,
            states: [],
            suburbs: [],
            address_type: 0,
            has_cp_info: true,
            is_submit_disabled: true,
            products:[],
        }
    },
    mounted() {
        if ($cookies.get("ctoken")) {
            this.getStates();
        }
    },
    watch: {
        "address.cp": function (newVal, oldVal) {
            if (newVal != undefined && newVal.length > 4) {
                axios({
                    method: "GET",
                    url: this.api_url + "/cpssepomex/cp/" + newVal,

                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + $cookies.get("ctoken"),
                    },
                }).then((response) => {
                    console.log('resp: ', response);
                    this.suburbs = response.data;
                    console.info("Datos de CP:");
                    console.info(this.suburbs);
                    this.address.suburb = this.suburbs[0].d_asenta;
                    this.address.cp = this.suburbs[0].d_codigo;
                    this.address.municipality = this.suburbs[0].d_mnpio;
                    this.address.state_id = parseInt(this.suburbs[0].c_estado);
                    this.address.state = this.suburbs[0].d_estado;
                    this.address.id = this.suburbs[0].id;
                    this.setAddressData(this.address);
                    this.has_cp_info = true;
                }).catch((error) => {
                    console.error(error);
                    this.$snotify.error("No hay información del CP");
                    this.has_cp_info = false;
                });
            }
        },
        address_type: function(newVal, oldVal){
           console.info("Hora de validar data");
           if (this.checkUserData(this.user) && this.checkAddressData(this.address)){
               console.info("Se valido al usuario y la direccion");
               this.is_submit_disabled = false;
           }
        }
    },
    methods: {
        setUserInfo: function(){
            console.info("Enviando la info al componente padre");
            //this.$emit("setUser", userData);
        },
        registerGuest: function(){
            axios({
                method: 'POST',
                url: this.api_url + '/subscribers/register-guest',
                data: this.user,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + $cookies.get("ctoken"),
                },
            }).then( (response) => {
                console.info("registrando usuario: " + this.user + " " + response);
                var today = new Date();
                if (response.data.status){
                    $cookies.set("utoken", response.data.token, today.getTime() + 3600000 * 24 * 7);
                    $cookies.set("uidmmkg", response.data.user.id, today.getTime() + 3600000 * 24 * 7);
                    eventBus.$emit("tokenSet", response.data.token);
                    
                    this.address.subscriber_id = response.data.user.id;
                    this.setUserData(response.data.user);
                    this.registerAddress();
                    // if(response.data.prev_registration){
                    //     console.log("el usuario ya tiene registro previo, se procede a borrar su carrito en el servidor y agregar el nuevo producto");
                    //     this.loadServerCart();
                    //     this.vaciarCarrito();
                    //     this.addLocalProductsToDataBase();
                    // }else{
                        this.addLocalProductsToDataBase();
                    // }
                }
            }).catch( (error)  => {
                console.error(error) ;
                this.$snotify.error(error);
            });
        },
        loadServerCart: function(){
            if($cookies.get("uidmmkg")){
                axios({
                    method: "GET",
                    url:
                        this.api_url +
                        "/cart/" +
                        $cookies.get("uidmmkg") +
                        "?v=" +
                        Math.floor(Date.now() / 1000),
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + $cookies.get("ctoken"),
                    },
                })
                    .then((response) => {
                        if (response.data.status) {
                            console.info("productos en el servidor: ", response.data.cart);
                            this.products = response.data.cart;
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                }
        },
        vaciarCarrito: function () {
            if($cookies.get("uidmmkg")){
                axios({
                    method: "POST",
                    url: this.api_url + "/cart/empty-cart/" + $cookies.get("uidmmkg"),
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + $cookies.get("ctoken"),
                    },
                })
                .then((response) => {
                    if (response.data.status) {
                        console.log("vaciando carrito: ", response.data);
                    } else {
                        console.log(response.data.message);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
            }
        },
        addLocalProductsToDataBase() {
            if (this.$store.state.cart.length > 0) {
                var products = this.$store.state.cart;
                axios({
                method: "POST",
                url: this.api_url + "/cart/store",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + $cookies.get("ctoken"),
                },
                data: {
                    user_id: $cookies.get("uidmmkg"),
                    items: products,
                },
                })
                .then((response) => {
                    console.info("productos agregados al servidor");
                    this.loadServerCart();
                })
                .catch((error) => {
                    console.error(error);
                });
            } 
        },
        registerAddress: function(){
            console.info("Registrando direccion");
            this.address.address_type_id = this.address_type;
            console.info(this.address);
            axios({
                method: "POST",
                url: this.api_url+"/address",
                data: this.address,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + $cookies.get("utoken"),
                },
            }).then( (response) => {
                console.info("Direccion registrada");
                console.info(response);
                if (!response.status){
                    this.$snotify.error("Hubo un error al registrar la información");
                }else{
                    this.setAddressData(response.data);
                }
            }).catch( (error) => {
                console.error(error);
                this.$snotify.error(error);
            });
        },
        getStates: function () {
            axios({
                method: "GET",
                url: this.api_url + "/state",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + $cookies.get("ctoken"),
                },
            }).then((response) => {
                this.states = response.data;
            }).catch((error) => {
                console.log("falloooo");
                console.error(error);
            });
        },
        setUserData: function (data){
            if (data){
                this.$emit("updateUser", data);
            }else{
                this.$emit("updateUser", {});
            }
        },
        setAddressData: function (data) {
            if (data) {
                this.$emit("update", data);
            } else {
                this.$emit("update", {});
            }
        },
        checkUserData: function(data){
            if (data.email.length>0 && data.name.length>0 && data.surname.length>0 && data.lastname.length>0 && data.phone.length>0){
                if (this.validEmail(data.email)){
                    return true;
                }
            }

            return false;
        },
        checkAddressData: function(data){
            if (data.cp && data.state_id && data.suburb && data.municipality && data.street && data.no_ext && data.btw_streets && data.references){
               if (this.address_type != 0){
                   return true;
               }
            }
            return false;
        },
        validEmail: function(email){
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    }
}
</script>
